import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";

import { getRequestGroup, getSubRequestGroup, updateRequestGroup, updateSubRequestGroup } from '../../api/routes';
import { useEffect, useState } from 'react';
import seperate from 'components/seperate';
import queryString from "../../components/queryString";
import { toast } from "react-toastify";

export default function Data() {
  const [groupOpen, setGroupOpen] = useState(false);
  const [subGroupOpen, setSubGroupOpen] = useState(false);
  const handleGroupOpen = () => setGroupOpen(Math.random() * 1000);
  const handleSubGroupOpen = () => setSubGroupOpen(Math.random() * 1000);
  const [groupClickedInfo, setGroupClickedInfo] = useState()
  const [subGroupClickedInfo, setSubGroupClickedInfo] = useState()

  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const [clickedGroupId, setClickedGroupId] = useState();
  useEffect(() => {
    const query = {
      all:1
    }
    getRequestGroup((isOk, data) => {
      if (!isOk) return toast.error(data.message);
      else return setData(data);
    },queryString(query))
  }, []);
  useEffect(() => {
    if (clickedGroupId || data.length > 0) {
      getSubRequestGroup(clickedGroupId ? clickedGroupId : data[0].requestGroupId, (isOk, data) => {
        if (!isOk) return toast.error(data.message);
        else return setData2(data);
      })
    }
  }, [clickedGroupId,data]);

  const updateGroup = (groupId, isActive) => {
    const data = {
      groupId: groupId,
      isActive: isActive,
    }
    updateRequestGroup(data, (isOk, data) => {
      if (!isOk) return toast.error(data.message);
      else return window.location.reload();
    })
  }
  const updateSubGroup = (subRequestGroupId, isActive) => {
    const data = {
      subRequestGroupId: subRequestGroupId,
      isActive: isActive,
    }
    updateSubRequestGroup(data, (isOk, data) => {
      if (!isOk) return toast.error(data.message);
      else return window.location.reload();
    })
  }
  return {
    columns: [
      { Header: "ردیف", accessor: "index", width: "1px", align: "center" },
      { Header: "نام گروه", accessor: "name", width: "10%", align: "left" },
      { Header: "وضعیت گروه", accessor: "status", align: "center" },
      { Header: "دفتر نوبت دهی؟", accessor: "isNoteBook", align: "center" },
      { Header: "اختصار", accessor: "shortName", width: "30%", align: "center" },
      { Header: "", accessor: "edit", width: "1px", align: "right" },
      { Header: "", accessor: "statusBtn", width: "1px", align: "left" },
    ],
    isGroupOpen: groupOpen,
    isSubGroupOpen: subGroupOpen,
    groupClickedInfo,
    subGroupClickedInfo,
    rows:
      data.map((item, index) => {
        return {
          index: <MDTypography component="p" variant="caption" color="text" fontWeight="medium">
            {index + 1}
          </MDTypography>,
          name: <MDTypography component="p" variant="caption" color="text" fontWeight="medium">
            {item.nameGroup}
          </MDTypography>,
          status: <MDTypography component="p" variant="caption" color="text" fontWeight="medium">
            {item.isActive ? 'فعال' : 'غیر فعال'}
          </MDTypography>,
          isNoteBook: <MDTypography component="p" variant="caption" color="text" fontWeight="medium">
            {item.isNoteBook ? 'بله' : 'خیر'}
          </MDTypography>,
          shortName: <MDTypography component="p" variant="caption" color="text" fontWeight="medium">
            {item.shortNameGroup}
          </MDTypography>,
          edit: (
            <MDBox sx={{ cursor: "pointer" }} ml={-1}>
              <MDBadge badgeContent="ویرایش گروه" color="blue" size="lg" onClick={() => { handleGroupOpen(); setGroupClickedInfo(item) }} />
            </MDBox>
          ),
          statusBtn:
            item.isActive ?
              <section style={{ display: 'flex' }}>
                <MDBox ml={-1} sx={{ cursor: "pointer" }} onClick={() => updateGroup(item.requestGroupId, 0)}>
                  <MDBadge badgeContent="غیر فعال کردن گروه" color="secondary" size="lg" />
                </MDBox>
                <MDBox ml={4} sx={{ cursor: "pointer" }} onClick={() => setClickedGroupId(item.requestGroupId)}>
                  <MDBadge badgeContent="نمایش زیر گروه" color="light" size="lg" />
                </MDBox>
              </section> :
              <section style={{ display: 'flex' }}>
                <MDBox ml={-1} sx={{ cursor: "pointer", width: '102px' }} onClick={() => updateGroup(item.requestGroupId, 1)}>
                  <MDBadge badgeContent="فعال کردن گروه" color="success" size="lg" />
                </MDBox>
                <MDBox ml={4} sx={{ cursor: "pointer" }} onClick={() => setClickedGroupId(item.requestGroupId)}>
                  <MDBadge badgeContent="نمایش زیر گروه" color="light" size="lg" />
                </MDBox>
              </section>
        }
      }
      ),
    subColumns: [
      { Header: "ردیف", accessor: "index", width: "1px", align: "center" },
      { Header: "نام زیر گروه", accessor: "name", width: "10%", align: "left" },
      { Header: "وضعیت زیر گروه", accessor: "status", align: "center" },
      { Header: "اختصار", accessor: "shortName", width: "1px", align: "center" },
      { Header: "قیمت", accessor: "price", width: "1px", align: "center" },
      { Header: "", accessor: "edit", width: "1px", align: "right" },
      { Header: "", accessor: "statusBtn", width: "1px", align: "left" },
    ],
    subRows:
      data2.map((item, index) => {
        return {
          index: <MDTypography component="p" variant="caption" color="text" fontWeight="medium">
            {index + 1}
          </MDTypography>,
          name: <MDTypography component="p" variant="caption" color="text" fontWeight="medium">
            {item.subNameGroup}
          </MDTypography>,
          status: <MDTypography component="p" variant="caption" color="text" fontWeight="medium">
            {item.isActive ? 'فعال' : 'غیر فعال'}
          </MDTypography>,
          shortName: <MDTypography component="p" variant="caption" color="text" fontWeight="medium">
            {item.shortSubNameGroup}
          </MDTypography>,
          price: <MDTypography component="p" variant="caption" color="text" fontWeight="medium">
            {seperate(item.price)+' تومان'}
          </MDTypography>,
          edit: (
            <MDBox sx={{ cursor: "pointer" }} ml={-1}>
              <MDBadge badgeContent="ویرایش زیر گروه" color="blue" size="lg" onClick={() => { handleSubGroupOpen(); setSubGroupClickedInfo(item) }} />
            </MDBox>
          ),
          statusBtn:
            item.isActive ?
              <MDBox ml={-1} sx={{ cursor: "pointer" }} onClick={() => updateSubGroup(item.subRequestGroupId, 0)}>
                <MDBadge badgeContent="غیر فعال کردن زیر گروه" color="secondary" size="lg" />
              </MDBox> :
              <MDBox ml={-1} sx={{ cursor: "pointer" }} onClick={() => updateSubGroup(item.subRequestGroupId, 1)}>
                <MDBadge badgeContent="فعال کردن زیر گروه" color="success" size="lg" />
              </MDBox>
          ,
        }
      }
      )
  };
}
